import Delta from 'quill-delta';
import { PathUtils } from 'slate';
import getNodeLength from '../utils/getNodeLength';
import convertNodeToOperations from '../utils/convertNodeToOperations';
import convertPathToOffset from '../utils/convertPathToOffset';
export default function moveNode(op, editor) {
  if (op.newPath === op.path) {
    // Nothing to see here
    return new Delta();
  }

  var node = editor.value.document.getNode(op.path);
  var parent = editor.value.document.getParent(op.newPath);
  var deletionLength = getNodeLength(node);
  var deletionOffset = convertPathToOffset(editor.value.document, op.path);
  var insertionOffset = convertPathToOffset(editor.value.document, op.newPath);

  if (PathUtils.isAfter(op.newPath, op.path)) {
    insertionOffset = insertionOffset - deletionLength;

    if (PathUtils.isSibling(op.newPath, op.path)) {
      // Node at newPath will move up
      var nodeAtNewPath = editor.value.document.getNode(op.newPath);
      insertionOffset = insertionOffset + getNodeLength(nodeAtNewPath);
    }

    return new Delta().retain(deletionOffset)["delete"](deletionLength).retain(insertionOffset - deletionOffset).concat(convertNodeToOperations(node, parent));
  } else {
    return new Delta().retain(insertionOffset).concat(convertNodeToOperations(node, parent)).retain(deletionOffset - insertionOffset)["delete"](deletionLength);
  }
}